import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "full-screen-loading d-block position-absolute start-0 top-0 end-0 bottom-0"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_4 = [
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'FullscreenLoading',
  props: {
  open: { type: Boolean, required: true }
},
  setup(__props) {

// props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})